import { render } from "./dialogflow.vue?vue&type=template&id=5219772e&scoped=true"
import script from "./dialogflow.vue?vue&type=script&lang=js"
export * from "./dialogflow.vue?vue&type=script&lang=js"

import "./dialogflow.vue?vue&type=style&index=0&id=5219772e&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5219772e"]])

export default __exports__